import React, { useState, useEffect } from 'react';
import axios from 'axios';

const T = { bg: '#f0f5e8', cream: '#fffef0', greenDk: '#1b5e20', maroon: '#6d1b1b', border: '#c8e6c9', header: 'linear-gradient(135deg, #090b72, #1a237e)' };

const GenTheetuPage = () => {
  const [data, setData] = useState([]);

  useEffect(() => {
    axios.get('/data/btheetu.json')
      .then(r => setData(r.data))
      .catch(e => console.error("Error loading btheetu data", e));
  }, []);

  const tbody = data.map(r => `
    <tr style="border-bottom:1px solid #ccc">
      <td style="padding:8px; border:1px solid #e0e0e0">${r.slno || ''}</td>
      <td style="padding:8px; border:1px solid #e0e0e0">${r.whome || ''}</td>
      <td style="padding:8px; border:1px solid #e0e0e0">${r.details || ''}</td>
      <td style="padding:8px; border:1px solid #e0e0e0">${r.period || ''} <br><small style="color:#6d1b1b">${r.extra || ''}</small></td>
    </tr>
  `).join('');

  return (
    <div style={{ padding: '15px', background: T.bg, minHeight: '100vh', fontFamily: 'sans-serif', lineHeight: 1.6 }}>
      <div style={{ background: T.header, padding: '12px', borderRadius: '10px', textAlign: 'center', marginBottom: '15px' }}>
        <h1 style={{ color: '#fff', margin: 0, fontSize: '1.2rem', fontWeight: 900 }}>அறிமுகம்</h1>
      </div>
      <div dangerouslySetInnerHTML={{ __html: `


  <h1>பிறப்புத் தீட்டுகள்</h1>
  
        <div class="head2">
          தீட்டு விளக்கம்
        </div>
      
  <div class="color4">
  <div class="div3">
        <ol class="myol">
          <li>பிறப்புத் தீட்டுக்கு ஜனன ஆசௌசம் என்று பெயர்.</li>
            <li>கல்யாணமாகாத ஆண், பெண் இருபாலருக்கும் எந்தத் தீட்டும் இல்லை.</li>
            <li>பிரசவத்தினால் ஏற்படும் தீட்டு பிரசவித்த பத்து நாளுக்குப் பிறகு எவரும் காக்கத் தேவையில்லை.</li>
            <li>பெண் குழந்தையைப் பெற்றவளுக்கு 40 நாட்கள் தீட்டு</li>
            <li>ஆண் குழந்தையைப் பெற்றவளுக்கு 30 நாட்கள் தீட்டு</li>
            <li>பிறந்தது பெண் குழந்தையானால் கீழ்கண்டவர்களுக்கு பத்து நாட்கள் தீட்டு: குழுந்தையின் உடன் பிறந்தோர்.<hr>
                மறுமனைவி(கள்) மூலம் பிறந்த ஸஹோதரர்கள்<hr>
                அதுபோல குழந்தையின் தகப்பனாரின் ஸஹோதரர்கள்
                <hr>
                குழந்தையின் தகப்பனாரின் தகப்பனார் 
                <hr>
                (பிதாமஹர்) அவரின் ஸஹோதரர்கள். மேற்கண்டோர் &nbsp; திருமணமான ஆண்களானால் அவர்களது மனைவிகளுக்கும் அதே அளவு தீட்டு.</li>
            <li>குழந்தை ஈன்றவளின் பெற்றோருக்கு 3 நாள் தீட்டு</li>
            <li>குழந்தை பெற்றவளின் ஸஹோதரன், மாமா, பெரியப்பர, சித்தப்பா போன்றவர்களுக்கு தீட்டில்லை
                ஆயினும் அவர்களில் யாருடைய பொருட் செலவிலாவது ப்ரஸவம் ஆனால், ப்ரஸவம் எங்கு நடந்தாலும்
                செலவு செய்தவர்களுக்கு ஒரு நாள் தீட்டுண்டு.</li>
        </ol>

  </div>
</div>
    
<div class="accordion">
  <details style="margin-bottom:10px; background:#fff; border-radius:8px; padding:10px; border:1px solid #c8e6c9">
    <summary style="font-weight:bold; cursor:pointer; color:#1b5e20; font-size:1.1rem; border-bottom:1px solid orange; padding-bottom:5px; margin-bottom:10px;"><span class="head3">
     பெற்றவளுக்கு மட்டும் 
    </span></summary>
    <div class="div3">    
ஜனனத்தில் குழந்தை பெற்றவளுக்கு மட்டும் சட்டி தொடடுதல் அதாவது சமையலறைக்கு வந்து
சமையல் செய்ய வீட்டுக் காரியங்களில் அனைவருக்கும் உள்ள பத்து நாள் தீட்டு முடிந்தவுடன்
ஈடுபட முடியாது.<hr>
ஆண் குழந்தையானால் 30 நாளும்<hr>
பெண் குழந்தையானால் 40 நாளுக்குப்பிறகே வீட்டுக் காரியங்களில்
ஈடுபட முடியும்.
</div>
    </details>
    <details style="margin-bottom:10px; background:#fff; border-radius:8px; padding:10px; border:1px solid #c8e6c9">
      <summary style="font-weight:bold; cursor:pointer; color:#1b5e20; font-size:1.1rem; border-bottom:1px solid orange; padding-bottom:5px; margin-bottom:10px;"><span class="head3">
          குறைப் ப்ரசவ தீட்டுகள்
        </span></summary>
      <div class="color4">
        <div class="div3">   
          ஏது காரணம் பற்றி ஒரு தாய்க்கு குறைப் பிரசவம் ஏற்பட்டால்
          கீழுள்ளவர்களுக்கு தீட்டு விபரம் தரப்பட்டுள்ளது. 
        <ol class="myol">
          <li>3 மாதத்தில் கலைந்து விழுந்தால் 
            தாய்க்கு மட்டில் (தூரம் போல) 3 நாள் தீட்டு. 
          </li>
          <li> 4 மாதத்தில் கலைந்தால் தாய்க்கு 4 நாள் தீட்டு,
            தந்தைக்கு ஸ்நானம் மட்டும் </li>
          <li>5 மாதத்தில் கலைந்தால் 
            தாய்க்கு 5 நாள் தீட்டு. தகப்பன் மற்றும் 10 நாள் பங்காளிகளுக்கும் ஸ்நானம் உண்டு. 
          </li>
          <li>6 மாதத்தில் கலைந்தால் தாய்க்கு 6 நாள் தீட்டு, 
            தந்தை மட்டும் பங்காளிகள் ஸ்நானம் பண்ணவேண்டும். 
          </li>
          <li>5 அல்லது 6ம் மாதம் கலைந்து பிண்டமாக விழுந்தால் 
            தாய்க்கு 5ம் மாதமெனில் 5 நாளும், 6ம் மாதம் எனில் 6 நாளும்,
            தந்தை மற்றும் பங்காளிகளுக்கு 3 நாள் தீட்டு உண்டு. 
          </li>
          <li> 6 மாதத்திற்கு மேலானால் தாய், தந்தைக்கு பத்து நாள் தீட்டு,
            குழந்தை ஆணானால் பங்காளிகளுக்கும் 
            பத்து நாள் தீட்டு உண்டு. 
            <span class="svk">
              குழந்தை பெண் என்றால் தீட்டு விஷயம் பற்றி இந்த நூலில் அறியமுடியவில்லை!
            </span>
          </li>

        </ol>
        </div>
      </div>
    </details>
    <details style="margin-bottom:10px; background:#fff; border-radius:8px; padding:10px; border:1px solid #c8e6c9">
      <summary style="font-weight:bold; cursor:pointer; color:#1b5e20; font-size:1.1rem; border-bottom:1px solid orange; padding-bottom:5px; margin-bottom:10px;"><span class="head3">
          மற்றவர்களுக்கு
        </span></summary>
      <div class="div3">
<table style="width:100%; border-collapse:collapse; margin-bottom:15px; background:#fffef0">
      <tr style="border-bottom:1px solid #ccc; font-weight: bold; background: #e8f5e9">
        <td style="padding:8px; border:1px solid #e0e0e0">No</td>
        <td style="padding:8px; border:1px solid #e0e0e0">யாருக்கு</td>
        <td style="padding:8px; border:1px solid #e0e0e0"> பிறப்பு விபரம் </td>
        <td style="padding:8px; border:1px solid #e0e0e0"> தீட்டு</td>        
      </tr>
      ${tbody}
    </table>
      </div>
    </details>
  </div>

` }} />
    </div>
  );
};

export default GenTheetuPage;
